export default __webpack_public_path__ + "static/N0316-c385f2be53349df9715254e14879a2af.png";